var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormGroup',{attrs:{"type":"select","options":_vm.prefList,"input-class":"w-full lg:w-200p","name":"pref","label":"都道府県","autocomplete":"address-level1","required":"","value":_vm.value,"errors":_vm.errors},on:{"input":s => _vm.$emit('input', s)}})
}
var staticRenderFns = []

export { render, staticRenderFns }